import * as Papa from 'papaparse';
import { isEqual } from 'vet-bones/utils';

import { ProjectFileUpload } from 'src/store/state/projects';
import { formatSeparator } from 'src/utils/csv/formatSeparator';

export const validateHeaders = (
  fileUpload: ProjectFileUpload,
  file: string | File
) => {
  return new Promise<boolean>((resolve) => {
    const handleComplete: Papa.ParseConfig['complete'] = (results) => {
      const fileUploadFields = fileUpload.fields
        .map((field) => field.value)
        .sort();

      if (!fileUpload.options.header) {
        // results.meta.fields is only available if header === true
        resolve(results.data.length === fileUploadFields.length);
      }

      const resultsFields = results.meta.fields?.sort();
      if (!resultsFields) {
        resolve(false);
      }

      resolve(isEqual(resultsFields, fileUploadFields));
    };

    const optionsToUse: Papa.ParseConfig = {
      complete: handleComplete,
      delimiter: formatSeparator(fileUpload.options.separator),
      escapeChar: fileUpload.options.escape,
      header: fileUpload.options.header,
      preview: 1,
      quoteChar: fileUpload.options.quote,
      step: (_, parser) => {
        parser.abort();
      },
    };

    Papa.parse(file as any, optionsToUse);
  });
};
